interface V3IconPinProps extends React.SVGProps<SVGSVGElement> {
    color?: string;
}

export const V3IconPin = ({ color = "#ABB0BA", ...rest }: V3IconPinProps) => <svg width="16" height="16" {...rest} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.736 8.213 7.523 2H3a1 1 0 0 0-1 1v4.523l6.213 6.213a1.036 1.036 0 0 0 1.381 0l4.142-4.142a1.036 1.036 0 0 0 0-1.38Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" fill={color} />
</svg>